import React, { useEffect, useState, useCallback } from 'react';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';
import classNames from 'classnames';
import 'react-circular-progressbar/dist/styles.css';
import { Checkmark } from './icons';
import './ProgressIcon.scss';

// 1. Destructure with default parameters in the signature
// 2. Keep React.memo to prevent unnecessary re-renders of the progress bar
const ProgressIcon = ({
  percentage = 0,
  colorScheme = 'red',
  imgSrc
}) => {
  const [progress, setProgress] = useState(0);

  const containerClassName = classNames('progress-icon', {
    [`progress-icon--${colorScheme}`]: colorScheme,
    'progress-icon--empty': percentage === 0
  });

  // Handle the progress animation debounce
  const debouncedProgress = useCallback(
    debounce((val) => setProgress(val), 250, { trailing: true }),
    [] // Stable reference
  );

  useEffect(() => {
    debouncedProgress(percentage);
    return () => debouncedProgress.cancel();
  }, [percentage, debouncedProgress]);

  return (
    <div className={containerClassName}>
      <img
        width="118px"
        height="118px"
        className="progress-icon__image"
        alt=""
        src={imgSrc}
      />
      <CircularProgressbar
        strokeWidth={5}
        value={progress}
        text={null}
      />
      {percentage === 100 && (
        <div className="progress-icon__checkmark">
          <Checkmark />
        </div>
      )}
    </div>
  );
};

ProgressIcon.propTypes = {
  percentage: PropTypes.number,
  colorScheme: PropTypes.oneOf(['red', 'green', 'blue']),
  imgSrc: PropTypes.string.isRequired
};

export default React.memo(ProgressIcon);
